type CustomStore = {
  getStore: () => Record<string, any> | undefined;
};

let customStore: CustomStore | undefined;

// Decision: see ADR-0005 — the store is swappable from outside so SSR can back it with AsyncLocalStorage.
export function getGlobalThat(): any {
  const globalAny: any = customStore?.getStore?.() ?? globalThis;
  if (!globalAny['__GLOBAL_THAT__']) {
    globalAny['__GLOBAL_THAT__'] = {};
  }
  return globalAny['__GLOBAL_THAT__'];
}

export function resetGlobalThat(): void {
  const globalAny: any = customStore?.getStore?.() ?? globalThis;
  if (globalAny['__GLOBAL_THAT__']) {
    globalAny['__GLOBAL_THAT__'] = {};
  }
}

export function installGlobalThat(customStoreToSet: CustomStore): void {
  customStore = customStoreToSet;
}
